import PropTypes from "prop-types";
import React, { createContext } from "react";

export const TextContext = createContext({
  size: "large",
  textType: "body",
});

TextContext.displayName = "TextContext";

export const TextProvider = (props) => {
  const { children, size, textType } = props;

  return <TextContext.Provider value={{ size, textType }}>{children}</TextContext.Provider>;
};

TextProvider.displayName = "TextProvider";

TextProvider.propTypes = {
  /** Content that will be rendered within the text provider */
  children: PropTypes.node,

  /** T-shirt size of styling that should be applied, such as "large" or "small." */
  size: PropTypes.oneOf(["large", "medium", "small", "xlarge", "xsmall"]),

  /** Indicates which typography group styling should be applied, such as "body" or "display." */
  textType: PropTypes.oneOf(["body", "details", "display", "label", "legal"]),
};
